export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xlg: 1200,
  xl: 1360,
};
